import { useState } from "react";
import { Link } from "react-router-dom";
import { MailCheck } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setSent(data.message);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="px-6 py-10" data-testid="forgot-password-page">
      <p className="eyebrow">Recupero accesso</p>
      <h1 className="font-serif text-4xl font-semibold text-[#0D2517]">Password dimenticata</h1>
      {sent ? (
        <div className="mt-8 space-y-5" data-testid="forgot-password-sent">
          <div className="flex gap-3 rounded-xl border border-[#c9a96e] bg-white p-4">
            <MailCheck size={20} className="shrink-0 text-[#b8975a]" />
            <p className="text-sm text-[#0d2517]" data-testid="forgot-password-message">{sent}</p>
          </div>
          <Link to="/accedi" className="btn-primary w-full" data-testid="forgot-back-login">TORNA ALL'ACCESSO</Link>
        </div>
      ) : (
        <>
          <p className="mt-2 text-sm text-[#5b6b60]">Inserisci l'email del tuo account: ti invieremo un link per impostare una nuova password.</p>
          <form onSubmit={submit} className="mt-8 space-y-3" data-testid="forgot-password-form">
            <input className="field" type="email" autoComplete="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email-input" />
            <button type="submit" disabled={busy} className="btn-primary w-full" data-testid="forgot-submit-button">{busy ? "Attendere…" : "INVIA IL LINK"}</button>
          </form>
          <Link to="/accedi" className="mt-5 block text-center text-sm text-[#0D2517] underline underline-offset-4" data-testid="forgot-cancel-link">Torna all'accesso</Link>
        </>
      )}
    </div>
  );
}
